export default {
  apiUrl() {
    return process.env.VUE_APP_API_URL;
  },
  appTitle() {
    return process.env.VUE_APP_TITLE;
  },
  vueAppLoginPath() {
    return process.env.VUE_APP_LOGIN_PATH;
  }
};
